import React from "react";
import CourseFilter from "@/components/courseFilter";
import SearchField from "@/components/searchField";
import Title from "@/components/title";
import ResultCard from "@/components/resultCard";
import AzureRequest from "@/services/request";
import DegreeLevel from "@/services/degreeLevel";
import capitalize from "@/services/capitalize";
import SearchHelp from "./searchHelp";
import Button from "@/components/button";
import RadioButton from "@/components/radioButton";
import HelpDialog from "@/components/helpDialog";
import getClosestFilter from "@/services/closestFilter";

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.coursesByPages = 1000;
    this.state = {
      searchTerms: this.props.searchValue,
      noResults: false,
      courses: [],
      displayedCourses: [],
      fields: [{ id: 0, name: "Domaine de formation" }],
      selectedField: { id: 0, name: "Domaine de formation" },
      workFields: [{ id: 0, name: "Domaine professionnel" }],
      selectedWorkField: { id: 0, name: "Domaine professionnel" },
      levels: [{ id: 0, name: "Niveau de diplôme" }],
      selectedLevel: { id: 0, name: "Niveau de diplôme" },
      locations: [{ id: 0, name: "Lieu de formation" }],
      selectedLocation: { id: 0, name: "Lieu de formation" },
      fieldsError: false,
      help: false,
      // loadedResults: 0,
      sort: "search.score()",
      injectedFilters: this.props.injectedFilters,
      helpDialog: false,
    };
    this.request = new AzureRequest();
    this.handleTermsChange = this.handleTermsChange.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleWorkFieldChange = this.handleWorkFieldChange.bind(this);
    this.handleLevelChange = this.handleLevelChange.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.getDegreeLevels = this.getDegreeLevels.bind(this);
    this.getFilters = this.getFilters.bind(this);
    this.doSearch = this.doSearch.bind(this);
    this.handleHelpClick = this.handleHelpClick.bind(this);
    this.handleHelpDialog = this.handleHelpDialog.bind(this);
    this.handleSortChange = this.handleSortChange.bind(this);
    this.loadMore = this.loadMore.bind(this);
  }

  componentDidMount() {
    if (this.props.searchValue) {
      this.doSearch();
    }
    this.getFilters();
    this.getDegreeLevels();
  }

  async componentDidUpdate(prevProps, prevState) {
    //Handle change on injectedFilters
    if (
      this.props.injectedFilters != null &&
      Object.keys(this.props.injectedFilters).length > 0 &&
      prevProps.injectedFilters !== this.props.injectedFilters
    ) {
      //Clear filters before inject new ones
      console.log("Clear");
      await this.clear();

      console.log(this.props.injectedFilters);
      await this.setState({
        injectedFilters: this.props.injectedFilters,
      });
    }
    if (
      this.state.injectedFilters &&
      Object.keys(this.state.injectedFilters).length > 0
    ) {
      let foundField = null;
      let foundWorkField = null;
      let foundLevel = null;
      let foundLocation = null;
      let search = "";
      let changed = false;
      if (
        this.state.injectedFilters.fields &&
        this.state.injectedFilters.fields.length > 0
      ) {
        foundField = getClosestFilter(this.state.injectedFilters.fields,this.state.fields);
        
        if (foundField != null) {
          this.state.injectedFilters.fields = null;
        }
        changed = true;
      }

      if (
        this.state.injectedFilters.workFields &&
        this.state.injectedFilters.workFields.length > 0
      ) {
        foundWorkField = getClosestFilter(this.state.injectedFilters.workFields,this.state.workFields);
        console.log(foundWorkField);
        console.log(this.state.injectedFilters.workFields);
        if (foundWorkField != null) {
          this.state.injectedFilters.workFields = null;
        }
        changed = true;
      }

      if (
        this.state.injectedFilters.levels &&
        this.state.injectedFilters.levels.length > 0
      ) {
        foundLevel = getClosestFilter(this.state.injectedFilters.levels,this.state.levels);
        if (foundLevel != null ) {
          this.state.injectedFilters.levels = null;
        }
        changed = true;
      }

      if (
        this.state.injectedFilters.locations &&
        this.state.injectedFilters.locations.length > 0
      ) {
        foundLocation = getClosestFilter(this.state.injectedFilters.locations,this.state.locations);
        if (foundLocation != null) {
          this.state.injectedFilters.locations = null;
        }
        changed = true;
      }

      if (
        this.state.injectedFilters.others &&
        this.state.injectedFilters.others.length > 0
      ) {
        search = this.state.injectedFilters.others;
        document.getElementById("courseSearch").value = search;
        changed = true;
      }
      else if(document.getElementById("courseSearch")?.value?.length > 0){
        search = '';
        document.getElementById("courseSearch").value = search;
        changed = true;
      }

      if (changed) {
        await this.setState({
          selectedField: foundField ? foundField : this.state.selectedField,
          selectedWorkField: foundWorkField ? foundWorkField : this.state.selectedWorkField,
          selectedLevel: foundLevel  ? foundLevel : this.state.selectedLevel,
          selectedLocation: foundLocation ? foundLocation : this.state.selectedLocation,
          searchTerms: search,
          injectedFilters: null,
          courses: [],
          loadedResults: 0,
        });
        this.doSearch();
      }
    }
  }

  doSearch() {
    let filters = [];
    if (this.state.selectedField.id > 0) {
      filters.push(`Domaine_du_MESRI eq '${this.state.selectedField.name}'`);
    }
    if (this.state.selectedWorkField.id > 0) {
      filters.push(
        `Domaine_Professionnel/any(field: field eq '${this.state.selectedWorkField.name}')`
      );
    }
    if (this.state.selectedLevel.id > 0) {
      const escapedLevels = this.state.selectedLevel.values.map((degree) =>
        degree.replace("'", "''")
      );
      filters.push(
        `(Type_de_diplome_lowercase eq '${escapedLevels.join(
          `' or Type_de_diplome_lowercase eq '`
        )}')`
      );
    }
    if (this.state.selectedLocation.id > 0) {
      filters.push(
        // `Commune_site_principal eq '${this.state.selectedLocation.name}'`
        `(Commune_site_principal eq '${this.state.selectedLocation.name}' or Commune_site_n_3/any(field: field eq '${this.state.selectedLocation.name}'))`
      );
    }
    const filter = filters.join(" and ");
    this.request
      .post({
        search: this.state.searchTerms,
        top: 1000,
        searchFields:
          "Domaine_du_MESRI_1,Domaine_du_MESRI,Domaine_Professionnel,Type_de_diplome,Parcours_Specialites_ED,Domaine_du_MESRI_1_lucene, Parcours_Specialites_ED_lucene",
        queryType: "full",
        filter: filter,
      })
      .then((response) => {
        console.log(response);
        this.setState({
          courses: response.value,
          noResults: response.value.length === 0,
          displayedCourses: response.value.slice(0, this.coursesByPages),
          sort: "search.score()",
        });
      })
      .catch((error) => console.log(error));
  }

  handleTermsChange(event) {
    this.setState({ searchTerms: event.target.value });
  }

  async handleFieldChange(value) {
    await this.setState({
      selectedField: value,
      courses: [],
      loadedResults: 0,
    });
    this.doSearch();
  }

  async handleWorkFieldChange(value) {
    await this.setState({
      selectedWorkField: value,
      courses: [],
      loadedResults: 0,
    });
    this.doSearch();
  }

  async handleLevelChange(value) {
    await this.setState({
      selectedLevel: value,
      courses: [],
      loadedResults: 0,
    });
    this.doSearch();
  }

  async handleLocationChange(value) {
    await this.setState({
      selectedLocation: value,
      courses: [],
      loadedResults: 0,
    });
    this.doSearch();
  }

  async handleSubmit(event) {
    event.preventDefault();
    await this.setState({
      courses: [],
      loadedResults: 0,
    });
    this.doSearch();
  }

  handleHelpClick(event) {
    this.setState({ help: !this.state.help });
  }

  handleHelpDialog(event) {
    this.setState({ helpDialog: !this.state.helpDialog });
  }

  handleSortChange(event) {
    let courses = [...this.state.courses];
    switch (event.target.value) {
      case "search.score()":
        courses.sort((a, b) => b["@search.score"] - a["@search.score"]);
        break;
      case "Type_de_diplome":
        courses.sort((a, b) => {
          // Order by degree level
          const orderA = this.state.levels.findIndex(
            (level) =>
              !!level.values &&
              level.values.some(
                (value) =>
                  value.toLowerCase() === a.Type_de_diplome?.toLowerCase()
              )
          );
          const orderB = this.state.levels.findIndex(
            (level) =>
              !!level.values &&
              level.values.some(
                (value) =>
                  value.toLowerCase() === b.Type_de_diplome?.toLowerCase()
              )
          );
          if (orderA !== orderB) {
            return orderA - orderB;
          }
          // then by degree name
          if (
            a.Type_de_diplome?.toLowerCase() < b.Type_de_diplome?.toLowerCase()
          ) {
            return -1;
          }
          if (
            a.Type_de_diplome?.toLowerCase() > b.Type_de_diplome?.toLowerCase()
          ) {
            return 1;
          }
          // then by course name
          if (
            a.Domaine_du_MESRI_1?.toLowerCase() <
            b.Domaine_du_MESRI_1?.toLowerCase()
          ) {
            return -1;
          }
          if (
            a.Domaine_du_MESRI_1?.toLowerCase() >
            b.Domaine_du_MESRI_1?.toLowerCase()
          ) {
            return 1;
          }
          // then by specialty
          if (
            a.Parcours_Specialites_ED?.toLowerCase() <
            b.Parcours_Specialites_ED?.toLowerCase()
          ) {
            return -1;
          }
          return 1;
        });
        break;
      default:
        break;
    }
    this.setState({
      sort: event.target.value,
      courses: courses,
      displayedCourses: courses.slice(0, this.coursesByPages),
    });
  }

  loadMore() {
    this.setState({
      displayedCourses: this.state.courses.slice(
        0,
        this.coursesByPages + this.state.displayedCourses.length
      ),
    });
  }

  getFilters() {
    this.request
      .post({
        top: 0,
        facets: [
          "Domaine_du_MESRI,count:200,sort:value",
          "Domaine_Professionnel,count:200,sort:value",
          "Commune_site_principal,count:200,sort:value",
        ],
      })
      .then((data) => {
        let locations = data["@search.facets"].Commune_site_principal.map(
          (location, index) => {
            return { id: index + 1, name: capitalize(location.value) };
          }
        );
        let fields = data["@search.facets"].Domaine_du_MESRI.map(
          (field, index) => {
            return { id: index + 1, name: capitalize(field.value) };
          }
        );
        let workFields = data["@search.facets"].Domaine_Professionnel.map(
          (field, index) => {
            return { id: index + 1, name: capitalize(field.value) };
          }
        );
        this.setState({
          fields: [{ id: 0, name: "Domaine de formation" }, ...fields],
          workFields: [{ id: 0, name: "Domaine professionnel" }, ...workFields],
          locations: [{ id: 0, name: "Lieu de formation" }, ...locations],
        });
      })
      .catch((error) => console.log("error", error));
  }

  getDegreeLevels() {
    const degreeLevel = new DegreeLevel();
    degreeLevel.typesByLevel().then((levels) => {
      levels.sort((a, b) => {
        const yearsA = a.name.match(/[0-9]+/);
        const yearsB = b.name.match(/[0-9]+/);
        // sort element with no number first
        if (!yearsA) return -1;
        if (!yearsB) return 1;
        // if numbers are equals, sort element with '>' last or element with '<' first
        if (yearsA[0] === yearsB[0])
          return a.name.search(/>/) || !a.name.search("<");
        // sort in growing order
        return yearsA[0] - yearsB[0];
      });
      levels.map((level) => {
        return {
          ...level,
          name: capitalize(level.name),
        };
      });
      return this.setState({
        levels: [
          ...this.state.levels,
          ...levels.map((level) => {
            return {
              ...level,
              name: capitalize(level.name),
            };
          }),
        ],
      });
    });
  }

  async clear(){
    await this.setState({
      noResults: false,
      displayedCourses: [],
      selectedField: { id: 0, name: "Domaine de formation" },
      selectedWorkField: { id: 0, name: "Domaine professionnel" },
      selectedLevel: { id: 0, name: "Niveau de diplôme" },
      selectedLocation: { id: 0, name: "Lieu de formation" },
      searchTerms: null,
      injectedFilters: null,
      loadedResults: 0,
    });
  }

  render() {
    return (
      <div className="flex-grow mt-14 pt-6 bg-khaki-light bg-open-book-left bg-no-repeat bg-left-top flex flex-col items-center">
        <section className="container w-3/4 lg:w-2/3">
          <Title
            title="Répertoire des formations"
            subtitle="Je recherche une formation par filière ou domaine professionnel"
            variant="2"
            justify="center"
          />
          <div className="mt-8">
            <button
              className="absolute transform -translate-x-16 m-2 hover:text-orange text-khaki-default fill-current"
              onClick={this.handleHelpClick}
              title="Conseils pour affiner votre recherche"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="44.49"
                height="44.49"
                viewBox="0 0 44.49 44.49"
              >
                <g transform="translate(0 0)">
                  <circle
                    cx="20"
                    cy="20"
                    r="20"
                    transform="translate(1.5 1.5)"
                    fill="#fff"
                  />
                  <path
                    d="M180.439,183.373a2.034,2.034,0,0,0-2.817.576,22.24,22.24,0,1,0,6.328-6.327,2.033,2.033,0,1,0,2.242,3.393,18.173,18.173,0,1,1-5.176,5.176A2.033,2.033,0,0,0,180.439,183.373Z"
                    transform="translate(-173.95 -173.95)"
                  />
                </g>
                <path
                  d="M8.492,0A7.349,7.349,0,0,0,1.964,3.453.911.911,0,0,0,2.16,4.7L3.8,5.94a.91.91,0,0,0,1.261-.157c.95-1.19,1.655-1.876,3.139-1.876,1.167,0,2.61.751,2.61,1.882,0,.855-.706,1.295-1.858,1.941C7.6,8.484,5.827,9.421,5.827,11.766v.371a.91.91,0,0,0,.91.91H9.486a.91.91,0,0,0,.91-.91v-.219c0-1.626,4.751-1.693,4.751-6.092C15.148,2.513,11.711,0,8.492,0ZM8.179,15.231a2.627,2.627,0,1,0,2.627,2.627A2.63,2.63,0,0,0,8.179,15.231Z"
                  transform="translate(14.2 12)"
                />
              </svg>
            </button>
            <form className="" onSubmit={this.handleSubmit}>
              <label className="bg-white border-2 border-khaki-default rounded-md flex justify-between py-2 px-4">
                <SearchField
                  handleChange={this.handleTermsChange}
                  defaultValue={this.props.searchValue}
                  onFocus={this.handleHelpDialog}
                />
                <button className="text-khaki-default">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
              </label>
            </form>
          </div>
          {this.state.help && <SearchHelp onClick={this.handleHelpClick} />}
          <div className="mt-4 grid xl:grid-cols-4 md:grid-cols-2 w-full gap-2">
            <span className="md:absolute md:transform md:-translate-x-24 py-2 uppercase">
              Filter par :
            </span>
            <CourseFilter
              options={this.state.fields}
              onChange={this.handleFieldChange}
              selected={this.state.selectedField}
              onClick={this.handleFieldOpen}
            />
            <CourseFilter
              options={this.state.workFields}
              onChange={this.handleWorkFieldChange}
              onClick={this.handleWorkFieldOpen}
              selected={this.state.selectedWorkField}
            />
            <CourseFilter
              options={this.state.levels}
              onChange={this.handleLevelChange}
              onClick={this.handleLevelOpen}
              selected={this.state.selectedLevel}
            />
            <CourseFilter
              options={this.state.locations}
              onChange={this.handleLocationChange}
              onClick={this.handleLocationOpen}
              selected={this.state.selectedLocation}
            />
          </div>
        </section>
        <section className="container w-11/12 mt-8">
          <Title title="Votre recherche" variant="3" justify="center" />
          {this.state.noResults && (
            <p className="text-center w-full">
              Aucune formation ne correspond à vos critères
            </p>
          )}
          {this.state.courses.length > 0 && (
            <div className="flex gap-2" onChange={this.handleSortChange.bind(this)}>
              <legend className="font-t-semibold text-gray-light">
                Trier par :
              </legend>
              <RadioButton
                group="sort"
                name="search.score()"
                label="Pertinence"
                checked={this.state.sort === "search.score()"}
              />
              <RadioButton
                group="sort"
                name="Type_de_diplome"
                label="Niveau de diplôme"
                checked={this.state.sort === "Type_de_diplome"}
              />
            </div>
          )}
          <div className="grid xl:grid-cols-4 md:grid-cols-2 w-full gap-2">
            {this.state.displayedCourses.map((course) => (
              <ResultCard
                key={course.AzureSearch_DocumentKey}
                course={course}
              />
            ))}
          </div>
        </section>
        {this.state.displayedCourses.length < this.state.courses.length && (
          <Button
            label="Charger plus de résultats"
            onButtonClick={this.loadMore}
            classes="px-4 my-6"
          />
        )}
        {this.state.helpDialog && (
          <HelpDialog handleClose={this.handleHelpDialog}>
            Pense à <button className="text-orange font-t-semibold" onClick={this.handleHelpClick}>consulter l'aide</button> pour connaître les commandes utiles pour affiner tes résultats de recherche
          </HelpDialog>
        )}
      </div>
    );
  } selectedField
}

export default Search;
